// Revise ▸ History: checkpoints, and what changed since one.
export { HistoryPage as component } from '../../views/HistoryPage.tsx';
export const room = 'revise';
export const page = 'history';
export const title = 'History';
export const help = 'checkpoints';
